import locales from "./locales/locales";
import router from './routes/routes'

export const AnnouncementsModule = {
    name: 'announcements',
    routes: router,
    locales: locales,
}